import React from 'react';
import Image from 'next/image';

import {
  BaseLeftWrapper,
  BaseRightWrapper,
  CocktailLeftWrapper,
  CocktailRightWrapper,
  CoffebarRightWrapper,
  FingerFoodLeftWrapper,
  FingerFoodRightWrapper,
  FoodTruckLeftWrapper,
  FoodTruckRightWrapper,
  HeroLeftWrapper,
  HeroRightWrapper,
  VeganLeftWrapper,
  VeganRightWrapper,
} from 'static_pages/components/styles';

const keywords = {
  vegan: {
    wrappers: [VeganLeftWrapper, VeganRightWrapper],
    left: {
      width: 290,
      height: 215,
    },
    right: {
      width: 270,
      height: 180,
    },
  },
  breakfast: {
    wrappers: [BaseLeftWrapper, BaseRightWrapper],
    left: {
      width: 250,
      height: 250,
    },
    right: {
      width: 216,
      height: 300,
    },
  },
  hero: {
    wrappers: [HeroLeftWrapper, HeroRightWrapper],
    left: {
      width: 500,
      height: 430,
    },
    right: {
      width: 200,
      height: 455.23520485584,
    },
  },
  dessert: {
    wrappers: [BaseLeftWrapper, BaseRightWrapper],
    left: {
      width: 300,
      height: 297,
    },
    right: {
      width: 300,
      height: 285,
    },
  },
  event: {
    wrappers: [BaseLeftWrapper, BaseRightWrapper],
    left: {
      width: 240,
      height: 324,
    },
    right: {
      width: 300,
      height: 270,
    },
  },
  buffet: {
    wrappers: [BaseLeftWrapper, BaseRightWrapper],
    left: {
      width: 300,
      height: 303,
    },
    right: {
      width: 300,
      height: 220,
    },
  },
  fingerfood: {
    wrappers: [FingerFoodLeftWrapper, FingerFoodRightWrapper],
    left: {
      width: 350,
      height: 144,
    },
    right: {
      width: 240,
      height: 220,
    },
  },
  foodtruck: {
    wrappers: [FoodTruckLeftWrapper, FoodTruckRightWrapper],
    left: {
      width: 300,
      height: 149,
    },
    right: {
      width: 300,
      height: 329,
    },
  },
  'lunch-dinner': {
    wrappers: [BaseLeftWrapper, BaseRightWrapper],
    left: {
      width: 300,
      height: 263,
    },
    right: {
      width: 300,
      height: 201,
    },
  },
  cocktailbar: {
    wrappers: [CocktailLeftWrapper, CocktailRightWrapper],
    left: {
      width: 250,
      height: 292,
    },
    right: {
      width: 280,
      height: 217,
    },
  },
  coffebar: {
    wrappers: [CocktailLeftWrapper, CoffebarRightWrapper],
    left: {
      width: 270,
      height: 225,
    },
    right: {
      width: 260,
      height: 251,
    },
  },
  bbq: {
    wrappers: [BaseLeftWrapper, BaseRightWrapper],
    left: {
      width: 280,
      height: 299,
    },
    right: {
      width: 280,
      height: 234,
    },
  },
};

function HeroImages({ keyword }) {
  const keywordImages = keywords[keyword];
  const [LeftWrapper, RightWrapper] = keywordImages.wrappers;
  return (
    <>
      <LeftWrapper>
        <Image
          alt=""
          src={`/artifacts/images/homepage/${keyword}-left-site.webp`}
          width={keywordImages.left.width}
          height={keywordImages.left.height}
          layout="intrinsic"
        />
      </LeftWrapper>

      <RightWrapper>
        <Image
          alt=""
          src={`/artifacts/images/homepage/${keyword}-right-site.webp`}
          width={keywordImages.right.width}
          height={keywordImages.right.height}
          layout="intrinsic"
        />
      </RightWrapper>
    </>
  );
}

export default HeroImages;
